exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".not-active {\n  pointer-events: none;\n  cursor: default;\n  color: lightgray; }\n\n.preview-link {\n  display: block;\n  margin-top: 5px; }\n\n.image-preview {\n  margin: 10px; }\n  .image-preview img {\n    max-width: 200px;\n    max-height: 200px; }\n\nmat-spinner {\n  display: inline-block;\n  height: 14px;\n  width: 14px;\n  overflow: hidden;\n  margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/formly/types/upload/file-upload.scss
// module id = ../../../../../src/app/common/formly/types/upload/file-upload.scss
// module chunks = main